var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "500px" },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        { attrs: { "min-width": "400px" } },
        [
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  staticClass: "ma-1",
                  attrs: { icon: "", color: "red" },
                  on: { click: _vm.onClose },
                },
                [_c("v-icon", [_vm._v("mdi-close")])],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-text-field", {
                staticClass: "ml-5 mr-5",
                attrs: {
                  label: "Order",
                  "hide-details": "",
                  type: "number",
                  outlined: "",
                  dense: "",
                },
                model: {
                  value: _vm.groupOrder,
                  callback: function ($$v) {
                    _vm.groupOrder = $$v
                  },
                  expression: "groupOrder",
                },
              }),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-text-field", {
                staticClass: "ml-5 mr-5",
                attrs: { label: "Group Name", outlined: "" },
                model: {
                  value: _vm.groupName,
                  callback: function ($$v) {
                    _vm.groupName = $$v
                  },
                  expression: "groupName",
                },
              }),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-color-picker", {
                staticClass: "ml-8",
                attrs: {
                  "dot-size": "25",
                  "swatches-max-height": "200",
                  width: "400px",
                  "show-swatches": "",
                  "hide-inputs": "",
                },
                model: {
                  value: _vm.groupColor,
                  callback: function ($$v) {
                    _vm.groupColor = $$v
                  },
                  expression: "groupColor",
                },
              }),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  staticClass: "ma-2",
                  attrs: { loading: _vm.buttonLoading, color: "primary" },
                  on: { click: _vm.onPressUpdate },
                },
                [_vm._v("UPDATE ")]
              ),
              _c("v-spacer"),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }